// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__35tKS","content":"style_content__1h7dk","description":"style_description__3qMUN","back":"style_back__35lO5","logo":"style_logo__vepv8"};